<template>
  <div class="schedule-view inner">
    <site-menu theme="dark" class="menu"/>
    <div class="content">
      <h1>Cannabis Political Economy Symposium Schedule</h1>
      <div class="day day-1" @click="day1open = !day1open">
        <h2>Wednesday, April 10, 2019</h2>
        <ul class="schedule" v-if="day1open">
          <li class="header">
            <div class="activity">Topic</div>
            <div class="time">Time</div>
            <div class="location">Location</div>
          </li>
          <li>
            <div class="activity">
              <b>Registration</b>
            </div>
            <div class="time">7:30am - 9am</div>
            <div class="location">Congressional Auditorium Atrium</div>
          </li>
          <li>
            <div class="activity">
              <b>Congressional Breakfast</b>
              <i>Congressman Earl Blumenauer</i>
            </div>
            <div class="time">8am - 9am</div>
            <div class="location">Congressional Auditorium Atrium</div>
          </li>
          <li>
            <div class="activity">
              <b>Welcome Address</b>
              <i>Dr.Paul White Jr.</i>
            </div>
            <div class="time">9am - 9:15am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Morning Keynote</b>
              <i>Dr.Brett Hollenbeck</i>
            </div>
            <div class="time">9:20am - 9:45am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Break / Networking</b>
            </div>
            <div class="time">9:45am - 10am</div>
            <div class="location">--</div>
          </li>
          <li>
            <div class="activity">
              <b>Market &amp; Investment Panel Discussion</b>
              <i>Moderator: Dr.Paul White Jr.</i>
              <i>Panelists: Josh Sanderlin, Lateema Spencer, Kennsley Dougan</i>
            </div>
            <div class="time">10am - 10:45am<br/><br/>Break<br/>10:45am - 11am<br/><br/>Reconvene<br/>11am - 11:45am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Cannabis &amp; Medical Use Panel Discussion</b>
              <i>Panelists: Dr.Jessica Lowe, AC Bradock, Deborah Walter</i>
            </div>
            <div class="time">10am - 10:45am<br/><br/>Break<br/>10:45am - 11am<br/><br/>Reconvene<br/>11am - 11:45am</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Speaker Series Luncheon</b>
              <i>Keynote Speakers: Congressman Lou Correa, Justin Strekal</i>
            </div>
            <div class="time">11:45am - 1:45pm</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Policy &amp; Public Administration Panel Discussion</b>
              <i>Panelists: Robert Raich, Carly Wolf, Nadir Pearson</i>
            </div>
            <div class="time">2pm - 2:45pm<br/><br/>Break<br/>2:45pm - 3pm<br/><br/>Reconvene<br/>3pm - 3:45pm</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Social Impact &amp; Equity</b>
              <i>Panelists: Sarah Gersten, Kevin Kimble, Kia Jackson</i>
            </div>
            <div class="time">2pm - 2:45pm<br/><br/>Break<br/>2:45pm - 3pm<br/><br/>Reconvene<br/>3pm - 3:45pm</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Evening Keynote</b>
              <i>Keynote Speaker: AC Bradock</i>
            </div>
            <div class="time">4pm - 5pm</div>
            <div class="location">Congressional Auditorium</div>
          </li>
        </ul>
      </div>
      <div class="day day-2" @click="day2open = !day2open">
        <h2>Thursday, April 11, 2019</h2>
        <ul class="schedule" v-if="day2open">
          <li class="header">
            <div class="activity">Topic</div>
            <div class="time">Time</div>
            <div class="location">Location</div>
          </li>
          <li>
            <div class="activity">
              <b>Registration</b>
            </div>
            <div class="time">7:30am - 9am</div>
            <div class="location">Congressional Auditorium Atrium</div>
          </li>
          <li>
            <div class="activity">
              <b>Welcome Address</b>
              <i>Dr.Paul White Jr.</i>
            </div>
            <div class="time">9am - 9:15am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Morning Keynote</b>
              <i>Former Congressman Jack Fields</i>
            </div>
            <div class="time">9:20am - 9:45am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Break / Networking</b>
            </div>
            <div class="time">9:45am - 10am</div>
            <div class="location">--</div>
          </li>
          <li>
            <div class="activity">
              <b>Market &amp; Investment Panel Discussion</b>
              <i>Moderator: Jared Johnson</i>
              <i>Panelists: Michael Flores, Jeff Doctor</i>
            </div>
            <div class="time">10am - 10:45am<br/><br/>Break<br/>10:45am - 11am<br/><br/>Reconvene<br/>11am - 11:45am</div>
            <div class="location">Congressional Auditorium</div>
          </li>
          <li>
            <div class="activity">
              <b>Cannabis &amp; Medical Use Panel Discussion</b>
              <i>Panelists: Dr.Adam Friedman, Dr.Jessica Knox, Dr.Liz Robinson</i>
            </div>
            <div class="time">10am - 10:45am<br/><br/>Break<br/>10:45am - 11am<br/><br/>Reconvene<br/>11am - 11:45am</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Speaker Series Luncheon</b>
              <i>Keynote Speakers: Dr.Soo Kang, Dr.Keaton Miller</i>
            </div>
            <div class="time">11:45am - 1:45pm</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Policy &amp; Public Administration</b>
              <i>Moderator: Dr.Keaton Miller</i>
              <i>Panelists: Axel Bernabe, Joel Braithwaite, Peggy Binzel, Kevin Kimble</i>
            </div>
            <div class="time">2pm - 2:45pm<br/><br/>Break<br/>2:45pm - 3pm<br/><br/>Reconvene<br/>3pm - 3:45pm</div>
            <div class="location">Congressional Auditorium<br/><br/>
            </div>
          </li>
          <li>
            <div class="activity">
              <b>Social Impact &amp; Equity Panel Discussion</b>
              <i>Moderator: Major Neil Franklin</i>
              <i>Panelists: Sarah Gersten, Dr.James Taylor, Lateema Spencer</i>
            </div>
            <div class="time">2pm - 2:45pm<br/><br/>Break<br/>2:45pm - 3pm<br/><br/>Reconvene<br/>3pm - 3:45pm</div>
            <div class="location">Congressional Visitor Center 268</div>
          </li>
          <li>
            <div class="activity">
              <b>Networking Reception</b>
            </div>
            <div class="time">4pm</div>
            <div class="location">TBD / On Campus</div>
          </li>
        </ul>
      </div>
      <h1>Congressional Auditorium<br/>of the United States House of Representative</h1>
      <div class="pictures">
        <figure>
          <img src="../assets/schedule/pic1.jpg" />
          <span>Congressional Auditorium Main Entrance</span>
        </figure>
        <figure>
          <img src="../assets/schedule/pic5.jpg" />
          <span>Congressional Auditorium Atrium Entrance</span>
        </figure>
        <figure>
          <img src="../assets/schedule/pic3.jpg" />
          <span>Congressional Auditorium Atrium</span>
        </figure>
        <figure>
          <img src="../assets/schedule/pic2.jpg" />
          <span>Congressional Visitor Center 268</span>
        </figure>
        <figure>
          <img src="../assets/schedule/pic6.jpg" />
          <span>Congressional Auditorium</span>
        </figure>
        <figure>
          <img src="../assets/schedule/pic4.jpg" />
          <span>Congressional Visitor Center 268</span>
        </figure>
      </div>
    </div>
  </div>
</template>

<script> 
  import SiteMenu from '@/components/SiteMenu.vue'
  import RegisterButton from '@/components/RegisterButton.vue'

  export default {
    name: 'schedule-view',
    components: { SiteMenu, RegisterButton },
    data() {
      return {
        day1open: false,
        day2open: false,
        day3open: false,
        day4open: false,
      }
    },
  }
</script>
<style scoped lang="scss">
  .content {
    max-width: 950px;
    margin: 0 auto;
  }
  h1 {
    text-align: center;
  }
  h2 {
    text-align: center;
    font-size: 35px;
    padding: 10px;
    margin: 0;
  }
  b {
    display: block;
    margin-bottom: 10px;
  }
  i { display: block; }
  .day {
    position: relative;
    font-size: 22px;
    color: #000;
    box-shadow: 0 0 5px #999;
    margin-bottom: 30px;
    .header {
      font-weight: bold;
    }
    .location ul {
      list-style: circle;
      padding-top: 5px;
      padding-left: 20px;
      text-align: left;
      font-size: 16px;
    }
  }
  .day-1 {
    h2 {
      color: $color-1;
    }
    .schedule {
      background: $color-1;
    }
  }
  .day-2 {
    h2 {
      color: $color-12;
    }
    .schedule {
      background: $color-12;
    }
  }
  .day-3 {
    box-shadow: 0 0 5px $color-13;
    h2 {
      color: $color-2;
    }
    .schedule {
      background: $color-2;
      color: #fff;
    }
  }
  .day-4 {
    h2 {
      color: $color-4;
    }
    .schedule {
      background: $color-4;
    }
  }
  .schedule {
    &::before {
      content: '';
      width: 28%;
      position: absolute;
      left: 42%;
      top: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.1);
    }
    >li {
      position: relative;
      overflow: hidden;
      line-height: 1.4;
      padding: 10px;
      >div {
        float: left;
        width: 28%;
        &.activity {
          width: 40%;
          margin-right: 4%;
        }
      }
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 1px;
        background: $color-1;
        background: linear-gradient(90deg, $color-5 0%, $color-1 100%);
      }
    }
  }
  .pictures {
    overflow: hidden;
    figure {
      margin: 0;
      position: relative;
      display: block;
      span {
        position: absolute;
        display: block;
        left: 30px;
        bottom: 8px;
        right: 30px;
        background: #00AB9A;
        color: #fff;
        text-transform: uppercase;
        padding: 10px;
        text-align: center;
        font-size: 11px;
        font-weight: bold;
        letter-spacing: 1px;
        height: 24px;
      }
      img {
        width: 100%;
      }
    }
  }
  .activity {
    .subtitle {
      font-size: 13px;
      text-transform: uppercase;
      letter-spacing: 1px;
      opacity: 0.5;
    }
    .details {
      margin-top: 10px;
      ul {
        list-style: circle;
        padding-left: 20px;
        font-size: 15px;
      }
    }
  }

  @media (min-width: 500px) {
    .pictures {
      figure {
        float: left;
        width: 33.3333%;
        box-sizing: border-box;
        padding: 0 5px 5px 0;
      }
    }
  }
  @media (max-width: 500px) {
    .pictures {
      figure span {
        bottom: 3px;
      }
    }
    .content {
      margin-top: 50px;
    }
    h1 {
      padding: 0 20px;
    }
    h1, h2 {
      font-size: 24px;
    }
  }
</style>